import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoTipoTesisArticuloDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoTipoTesisArticuloService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoTipoTesisArticuloService(): Observable<BodyListResponse<CatalogoTipoTesisArticuloDTO>> {
    return this.http.get<BodyListResponse<CatalogoTipoTesisArticuloDTO>>(API_URL + '/api/v1/catalogoTipoTesisArticulo/todos');
  }

  guardarCatalogoTipoTesisArticuloService(catalogoTipoTesisArticuloDTO: CatalogoTipoTesisArticuloDTO): Observable<CatalogoTipoTesisArticuloDTO> {
    return this.http.post<CatalogoTipoTesisArticuloDTO>(API_URL + '/api/v1/catalogoTipoTesisArticulo', catalogoTipoTesisArticuloDTO);
  }

  getCatalogoTipoTesisArticuloPorCodigoCatalogoTipoTesisArticuloService(codigoCatalogoTipoTesisArticulo: string): Observable<BodyResponse<CatalogoTipoTesisArticuloDTO>> {
    return this.http.get<BodyResponse<CatalogoTipoTesisArticuloDTO>>(API_URL + '/api/v1/catalogoTipoTesisArticulo/' + codigoCatalogoTipoTesisArticulo);
  }
}
